import SeoPage from "./SeoPage";

export default function CompressVideoFree() {
    return (
        <SeoPage
            heading="Compress Video Online Free"
            intro="Compress large video files online for free. No signup, fast processing, and privacy-first video compression."
            title="Compress Video Online Free – TinyCompression"
            description="Compress video online for free with TinyCompression. Reduce MP4 file size instantly without installing software. Reliable, secure, and private."
        />
    );
}
